import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AccountCardWrapper } from "../../components/AccountCardWrapper";
import { SetupPageContainer } from "../../../utils/commonStyledComponents/commonStyled";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { adminApiService } from "../../../utils/api";
import { messages } from "../../../locales/messages";
import { StyledButton } from "./styled";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { useState } from "react";

const CachePage = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleCleanCache = async () => {
    setIsLoading(true);
    try {
      toastSuccess(`${t(messages.INITIALIZE_CLEAR_ALL_CACHE())} `);
      await adminApiService.gfMiscellaneousAdminControllerClearCache();
      toastSuccess(`${t(messages.CLEAR_ALL_CACHE_SUCCESS())} `);
    } catch (error) {
      toastError(`${t(messages.CLEAR_ALL_CACHE_FAILED())} `);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <SetupPageContainer>
      <AccountCardWrapper title="Cache">
        <Box
          sx={{
            marginTop: "20px",
            marginBottom: "20px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            rowGap: "20px",
          }}
        >
          <StyledButton
            endIcon={
              isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <AutorenewIcon />
              )
            }
            disabled={isLoading}
            onClick={handleCleanCache}
          >
            {t(messages.CLEAR_ALL_CACHE())}
          </StyledButton>
        </Box>
      </AccountCardWrapper>
    </SetupPageContainer>
  );
};

export default CachePage;
